<div class="branch-header position-relative text-center">
  <img
    src="/assets/img/resources/branches/branch-banner.jpg"
    alt=""
    class="img-fluid"
  />
</div>

<div class="row g-0" style="height: 100vh; overflow: hidden">
  <div
    class="col-lg-3 bg-light border-end d-flex flex-column"
    style="height: 100vh"
  >
    <div class="search-box p-3 bg-light border-bottom">
      <div class="input-group shadow-sm rounded-pill overflow-hidden">
        <input
          type="text"
          class="form-control border-0 ps-3"
          placeholder="Search branch..."
          [(ngModel)]="searchQuery"
          (input)="onSearchInput($event)"
        />
        <button
          *ngIf="searchQuery"
          class="btn btn-light px-3 border-0"
          (click)="clearSearch()"
          type="button"
        >
          <i class="bi bi-x-lg"></i>
        </button>
        <button class="btn btn-success" (click)="searchBranches()">
          <i class="bi bi-search"></i>
        </button>
      </div>
      <div
        *ngIf="searchQuery && filteredBranches.length === 0"
        class="mt-2 text-center"
      >
        <small class="text-muted">No branches found</small>
      </div>
      <div
        *ngIf="searchQuery && filteredBranches.length > 0"
        class="mt-2 text-center"
      >
        <small class="text-muted"
          >{{ filteredBranches.length }} branch(es) found</small
        >
      </div>
    </div>

    <div class="branch-list flex-grow-1 overflow-auto p-3">
      <div
        *ngFor="let branch of filteredBranches"
        class="card mb-3 cursor-pointer hover-shadow"
        (click)="selectBranch(branch)"
        [class.border-success]="selectedBranch?.id === branch.id"
      >
        <img
          [src]="branch.image"
          class="card-img-top"
          alt="{{ branch.name }}"
          (error)="setBranchImageFallback($event)"
          style="height: 150px; object-fit: cover"
        />
        <div class="p-2 position-relative">
          <div class="d-flex justify-between flex-row">
            <div>
              <h2 class="card-title mb-1 h6">{{ branch.name }}</h2>
              <small class="text-muted d-block">{{ branch.location }}</small>
            </div>
          </div>

          <div
            *ngIf="branch.distance !== undefined"
            class="position-absolute bottom-0 end-0 mb-2 me-2"
          >
            <small class="text-muted"
              >{{ branch.distance | number : "1.1-1" }} km away</small
            >
          </div>
        </div>

        <div class="details p-3">
          <div class="mb-3" *ngIf="branch.address">
            <div class="d-flex align-items-start">
              <i class="bi bi-pin-map text-success me-2 mt-1"></i>
              <div>
                <small class="text-muted d-block mb-1">Address</small>
                <p class="mb-0 small">{{ branch.address }}</p>
              </div>
            </div>
          </div>

          <div class="mb-3" *ngIf="branch.landmark">
            <div class="d-flex align-items-start">
              <i class="bi bi-signpost-2 text-success me-2 mt-1"></i>
              <div>
                <small class="text-muted d-block mb-1">Landmark</small>
                <p class="mb-0 small">{{ branch.landmark }}</p>
              </div>
            </div>
          </div>

          <div class="mb-3" *ngIf="branch.business_hours">
            <div class="d-flex align-items-start">
              <i class="bi bi-clock text-success me-2 mt-1"></i>
              <div>
                <small class="text-muted d-block mb-1">Business Hours</small>
                <p class="mb-0 small fw-semibold">
                  {{ branch.business_hours }}
                </p>
              </div>
            </div>
          </div>

          <div class="border-top pt-3 mb-3">
            <small class="text-muted fw-semibold d-block mb-2"
              >Contact Information</small
            >

            <div class="mb-2" *ngIf="branch.landline.length > 0">
              <div class="d-flex align-items-center">
                <i class="bi bi-telephone text-success me-2"></i>
                <a
                  href="tel:{{ branch.landline }}"
                  class="text-decoration-none small"
                >
                  {{ branch.landline }}
                </a>
              </div>
            </div>

            <div class="mb-2" *ngIf="branch.textline">
              <div class="d-flex align-items-center">
                <i class="bi bi-chat-dots text-success me-2"></i>
                <a
                  href="sms:{{ branch.textline }}"
                  class="text-decoration-none small"
                >
                  {{ branch.textline }}
                </a>
              </div>
            </div>

            <div class="mb-2" *ngIf="branch.email">
              <div class="d-flex align-items-center">
                <i class="bi bi-envelope text-success me-2"></i>
                <a
                  href="mailto:{{ branch.email }}"
                  class="text-decoration-none small"
                >
                  {{ branch.email }}
                </a>
              </div>
            </div>
          </div>

          <div class="mb-3" *ngIf="branch.toll_fee">
            <div class="alert alert-light border mb-0 py-2 px-3">
              <div class="d-flex align-items-center">
                <i class="bi bi-cash-coin text-warning me-2"></i>
                <div>
                  <small class="text-muted d-block">Toll Fee</small>
                  <span class="small fw-semibold">{{ branch.toll_fee }}</span>
                </div>
              </div>
            </div>
          </div>

          <div
            *ngIf="
              branch.additional_details && branch.additional_details.length > 0
            "
            class="border-top pt-3"
          >
            <small class="text-muted fw-semibold d-block mb-2"
              >Additional Information</small
            >
            <div *ngFor="let detail of branch.additional_details" class="mb-2">
              <div class="d-flex align-items-start">
                <i class="bi bi-info-circle text-success me-2 mt-1"></i>
                <div class="flex-grow-1">
                  <small class="text-muted d-block">{{ detail.key }}</small>
                  <span class="small">{{ detail.value }}</span>
                </div>
              </div>
            </div>
          </div>

          <div
            class="p-3 border-top bg-light"
            style="border-radius: 0 0 8px 8px"
          >
            <div class="d-grid gap-2">
              <button
                class="btn btn-success btn-sm"
                (click)="openInGoogleMaps(branch.address)"
              >
                <i class="bi bi-navigation me-2"></i>Get Directions
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>

  <div class="map-section col-lg-9 position-relative" style="height: 100vh">
    <google-map height="100vh" width="100%" [center]="mapCenter" [zoom]="zoom">
      <!-- Branch locations -->
      <map-marker
        *ngFor="let branch of filteredBranches"
        [position]="{ lat: branch.lat, lng: branch.lng }"
        [title]="branch.name"
        (mapClick)="selectBranch(branch)"
      ></map-marker>

      <!-- Device current location -->
      <map-marker
        *ngIf="currentLat && currentLng"
        [position]="{ lat: currentLat, lng: currentLng }"
        title="You are here"
        icon="http://maps.google.com/mapfiles/ms/icons/blue-dot.png"
      ></map-marker>

      <map-circle
        *ngIf="currentLat && currentLng"
        [center]="{ lat: currentLat, lng: currentLng }"
        [radius]="100"
        [options]="{ fillColor: '#3b82f6', fillOpacity: 0.2, strokeWeight: 0 }"
      ></map-circle>
    </google-map>

    <div
      *ngIf="selectedBranch"
      class="branch-info-card shadow-lg bg-white rounded position-absolute"
      style="
        bottom: 20px;
        left: 20px;
        max-width: 380px;
        max-height: calc(100vh - 100px);
        overflow-y: auto;
      "
    >
      <div class="branch-image-wrapper position-relative">
        <img
          [src]="selectedBranch.image"
          alt="{{ selectedBranch.name }}"
          class="w-100"
          (error)="setBranchImageFallback($event)"
          style="height: 180px; object-fit: cover; border-radius: 8px 8px 0 0"
        />
      </div>

      <div class="p-3 border-bottom">
        <h5 class="mb-1 fw-bold">{{ selectedBranch.name }}</h5>
        <p class="text-muted mb-0 small">
          <i class="bi bi-geo-alt-fill text-success me-1"></i>
          {{ selectedBranch.location }}
        </p>
      </div>

      <div class="p-3">
        <div class="mb-3" *ngIf="selectedBranch.address">
          <div class="d-flex align-items-start">
            <i class="bi bi-pin-map text-success me-2 mt-1"></i>
            <div>
              <small class="text-muted d-block mb-1">Address</small>
              <p class="mb-0 small">{{ selectedBranch.address }}</p>
            </div>
          </div>
        </div>

        <div class="mb-3" *ngIf="selectedBranch.landmark">
          <div class="d-flex align-items-start">
            <i class="bi bi-signpost-2 text-success me-2 mt-1"></i>
            <div>
              <small class="text-muted d-block mb-1">Landmark</small>
              <p class="mb-0 small">{{ selectedBranch.landmark }}</p>
            </div>
          </div>
        </div>

        <div class="mb-3" *ngIf="selectedBranch.business_hours">
          <div class="d-flex align-items-start">
            <i class="bi bi-clock text-success me-2 mt-1"></i>
            <div>
              <small class="text-muted d-block mb-1">Business Hours</small>
              <p class="mb-0 small fw-semibold">
                {{ selectedBranch.business_hours }}
              </p>
            </div>
          </div>
        </div>

        <div class="border-top pt-3 mb-3">
          <small class="text-muted fw-semibold d-block mb-2"
            >Contact Information</small
          >

          <div class="mb-2" *ngIf="selectedBranch.landline">
            <div class="d-flex align-items-center">
              <i class="bi bi-telephone text-success me-2"></i>
              <a
                href="tel:{{ selectedBranch.landline }}"
                class="text-decoration-none small"
              >
                {{ selectedBranch.landline }}
              </a>
            </div>
          </div>

          <div class="mb-2" *ngIf="selectedBranch.textline">
            <div class="d-flex align-items-center">
              <i class="bi bi-chat-dots text-success me-2"></i>
              <a
                href="sms:{{ selectedBranch.textline }}"
                class="text-decoration-none small"
              >
                {{ selectedBranch.textline }}
              </a>
            </div>
          </div>

          <div class="mb-2" *ngIf="selectedBranch.email">
            <div class="d-flex align-items-center">
              <i class="bi bi-envelope text-success me-2"></i>
              <a
                href="mailto:{{ selectedBranch.email }}"
                class="text-decoration-none small"
              >
                {{ selectedBranch.email }}
              </a>
            </div>
          </div>
        </div>

        <div class="mb-3" *ngIf="selectedBranch.toll_fee">
          <div class="alert alert-light border mb-0 py-2 px-3">
            <div class="d-flex align-items-center">
              <i class="bi bi-cash-coin text-warning me-2"></i>
              <div>
                <small class="text-muted d-block">Toll Fee</small>
                <span class="small fw-semibold">{{
                  selectedBranch.toll_fee
                }}</span>
              </div>
            </div>
          </div>
        </div>

        <div class="p-3 border-top bg-light" style="border-radius: 0 0 8px 8px">
          <div class="d-grid gap-2">
            <button
              class="btn btn-success btn-sm"
              (click)="openInGoogleMaps(selectedBranch.lat, selectedBranch.lng)"
            >
              <i class="bi bi-navigation me-2"></i>Get Directions
            </button>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
